var map = {
  "./cs.json": [
    "SZg",
    [
      "kxv"
    ]
  ],
  "./en.json": [
    "w3",
    [
      "2u"
    ]
  ],
  "./pl.json": [
    "lK",
    [
      "z6"
    ]
  ],
  "./ru.json": [
    "s5R",
    [
      "e4s"
    ]
  ],
  "./tr.json": [
    "Q0",
    [
      "ie"
    ]
  ],
  "./ja.json": [
    "cM",
    [
      "ya"
    ]
  ],
  "./zh.json": [
    "M6",
    [
      "ytt"
    ]
  ],
  "./pt-br.json": [
    "dg",
    [
      "rq"
    ]
  ],
  "./de.json": [
    "be5",
    [
      "tn"
    ]
  ],
  "./es.json": [
    "qd",
    [
      "wxt"
    ]
  ],
  "./fr.json": [
    "B2",
    [
      "n"
    ]
  ],
  "./it.json": [
    "QC",
    [
      "q0"
    ]
  ],
  "./ko.json": [
    "mO",
    [
      "cq"
    ]
  ],
  "./pt.json": [
    "Te",
    [
      "9rj"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "mdy";
module.exports = __rspack_async_context;
